import type Quill from '../core';

export default new WeakMap<Node, Quill>();
